var exports = {
  "list": "x1cb7f6e3--0eb2dc--list",
  "phone": "x1cb7f6e3--0eb2dc--phone",
  "item": "x1cb7f6e3--0eb2dc--item",
  "tooltip-icon": "x1cb7f6e3--0eb2dc--tooltip-icon",
  "button": "x1cb7f6e3--0eb2dc--button",
  "text-wrapper": "x1cb7f6e3--0eb2dc--text-wrapper",
  "desktop": "x1cb7f6e3--0eb2dc--desktop",
  "value": "x1cb7f6e3--0eb2dc--value",
};

module.exports = exports;
